"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const frontendApps_1 = require("../../utils/frontendApps");
exports.Link = react_router_1.withRouter(({ history, to, staticContext, ...props }) => {
    return (react_1.default.createElement("a", Object.assign({ href: to, onClick: e => {
            if (frontendApps_1.withinSameFrontendApp(location.pathname, to)) {
                // don't reload everything, just navigate in JS land
                history.push(to);
                e.preventDefault();
            }
            // different app, so let the <a> do its thing and reload the page
        } }, props)));
});
//# sourceMappingURL=Link.js.map